import React, { useState } from 'react';
import SocialLocationPostContainer from '../../../SocialLocationPostContainer';
import translate from '../../../../../config/translations/translate';

let setModalOpen;
let publicHandleApply; //el handleapply de index. (details)

export const openPostModal = (socialLocationId, handleApply) => {
  publicHandleApply = handleApply;
  if (setModalOpen) {
    setModalOpen(socialLocationId);
  }
};

const PostModalContainer = ({ t, runningPostProcessId, setRunningPostProcessId }) => {
  const [isPostModalOpen, setIsPostModalOpen] = useState();
  
  setModalOpen = setIsPostModalOpen;

  return (
    <SocialLocationPostContainer
      modal={{
        isOpen: isPostModalOpen !== undefined,
        toggle: () => setIsPostModalOpen(undefined),
      }}
      socialLocationId={isPostModalOpen}
      handleApply={publicHandleApply}
      onProcessStart={(processId) => setRunningPostProcessId && setRunningPostProcessId(processId)}
      onProcessEnd={() => setRunningPostProcessId && setRunningPostProcessId(null)}
    />
  );
};

export default translate(PostModalContainer);